import { SVGProps, Ref, forwardRef } from 'react';

export const LoaderOutlinedSize96Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={96} height={96} viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M48 11.2A36.8 36.8 0 1 0 84.8 48H92A44 44 0 1 1 48 4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
LoaderOutlinedSize96Glyph.displayName = 'LoaderOutlinedSize96Glyph';
